module.exports = __webpack_public_path__ + "img/testimonial.341a1092.jpg";